import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

import { AuthService } from '../../../core/auth/auth.service';
import { User }    from '../user';
import { Router } from '@angular/router';
import { API_ERROR } from '../../../utils/api-error.const';
import { environment } from '../../../../environments/environment';
import {TranslateService} from "@ngx-translate/core";
import {Organisation} from "../../../bo/organization/organisation";
import {Payement} from "../../../bo/organization/payment";
import {OrganizationService} from "../../../bo/organization/organization.service";
import {FonctionUtiles} from "../../../utils/fonctionsUtiles";
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.css']
})


export class SignupFormComponent implements OnInit {
  @Input() displayLinks: boolean = true;
  @Input() full : any = false;
  @Output() messageEvent = new EventEmitter<string>();
  @Output() signedUp = new EventEmitter<any>();
  modePro: boolean;
  account = new User();
  submitted = false;
  errorMsg = '';
  redirect: string;
  state: string;
  userIsSigned = false;
  condition :any=false;
  hidePassword : boolean = true;
  errors: any = [];
  orgaDataFormerrors: any = [];
  paymentDataFormerrors: any = [];
  //patch because login and signup is used when booking
  @Input() isShoppingFunnel : any = false;
  orgaSignupStepCurrentIdx:any;
  data: string;
  payentDataFormValidity: boolean = false;
  orgaDataFormValidity: boolean = false;
  acountName = '';

  //this variable is on login component to ,it used to patch template inorganisation
  logoName:any;
  you_must_accept_term_and_conditions = '';
  organisation : any = new Organisation();
  payment: any = new Payement();

  constructor(private toastr: ToastrService,private translateService:TranslateService,private authService: AuthService,private router :Router, private organisationservice :OrganizationService,private functionUtiles: FonctionUtiles) {
      this.state = authService.destination;
      this.modePro = environment.pro;
    //pro is using old template like shoppingtunnel,it is patching
      this.isShoppingFunnel = environment.pro;
  }
  initials() {
    return this.functionUtiles.getInitials(this.authService.acountName);
  }

  eventTypeList = ['Business','Concert','Conférence','Culturel','Clubbing','Gala','Sport'];
  orgaTypeList = ['Association','Particulier ','Professionnel'];


  isProSignupProcessgoin() {
    return this.authService.isProSignupProcessgoin;
  }
  orgaSignupSteps = [
    {'index':1,'name':'vos informations' ,'isCurent': false},
    {'index':2,'name':'votre organisation','isCurent': true},
    {'index':3,'name':'vos coordonnées bancaires','isCurent': false}
    ];
  signedUpDone() {
    this.authService.changeData('signedUp');
  }

  ngOnInit() {
    this.authService.data$.subscribe(res => this.data = res);
    this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';
    if(this.modePro) {
      this.full = true;
    }
    this.translateService.get('shared_sign_up_form.you_must_accept_term_and_conditions').subscribe(
      value => {
        this.you_must_accept_term_and_conditions = value;
      }
    );
   /* if(this.authService.isProSignupProcessgoin) {
    }*/

   if(this.authService.isProSignupProcessgoin) {
      this.orgaSignupStepCurrentIdx = 2;
   }

   if(this.authService.loggedIn()) {
      this.orgaSignupStepCurrentIdx = 2;
   } else if(this.authService.isProSignupProcessgoin) {
      this.orgaSignupStepCurrentIdx = 2;
   }
  }
  toglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  validation(validity): boolean  {
    this.errors = [];
    if (!validity) {
      this.errors.push('Formulaire incomplet');
      return false;
    }
    return true;
  }

  orgaDataSubmit(validity) {
     this.orgaDataFormValidity = validity;
     this.organisationservice.saveOrganization(this.organisation).then(res => {})
  }
  paymentDataSubmit(validity) {
     this.payentDataFormValidity = validity;
     this.organisationservice.savepaiement(this.payment).then(res => {})
  }

  onSubmit(validity) {
    console.log('submited');
    if(this.validation(validity)) {
      if(!this.condition) {
        this.toastr.info(this.you_must_accept_term_and_conditions, 'Info');

        //alert();
        return;
      }
      this.submitted = true;
      let language = this.authService.retrieve('curentLang');
      this.account.lang = language || 'fr';
      this.signedUp.emit('signed');
      console.log(this.account);
      this.authService.acountName = this.account.firstname+ ' ' + this.account.lastname;
      this.authService.store('acountName',this.account.firstname+ ' ' + this.account.lastname);

      this.authService.signup(this.account).then(res => {
        console.log(this.account);
        // if registration succeed, log user with its credentials
        // TODO: #LOW log directly user in api signup and return a token?
        this.authService.login(this.account.email, this.account.password)
          .then(res => {
            if(this.modePro) {
              this.authService.isProSignupProcessgoin = true;
              this.authService.store('isProSignupProcessgoin',true);
              this.signedUpDone();
            } else {
              if(!this.isShoppingFunnel) {
                this.router.navigate(['/']);
              }
              this.userIsSigned = true;
              this.messageEvent.emit("non");
            }
          })
          .catch(error => {
            console.log(error);
            this.errorMsg = API_ERROR.get(error.code);
          });
      }).catch(error => {
        console.log(error);
          if (error.status === 422) {
            this.errorMsg = 'Email déja utilisé, vueillez vous connecter';
          } else if (error.error.message) {
            this.errorMsg = error.msg;
          } else {
            this.errorMsg = API_ERROR.get(error.code);
          }
        });
    }
  }

  moveToLink(){
    this.router.navigate(['/account']);
  }

  moveToCreate(){
    this.router.navigate(['/manage/event/create']);
  }

  loggedIn() {
    return this.authService.loggedIn();
  }
  clickOrgaSignupStep (idx) {
    this.orgaSignupStepCurrentIdx = idx;
  }
  nextStep() {
    if(this.orgaSignupStepCurrentIdx === 2) {
      let $ = window['jQuery'];
      $('#orgaDataBtn').click();
      if(this.orgaDataFormValidity) {
        this.orgaSignupStepCurrentIdx ++;
      }
    } else if (this.orgaSignupStepCurrentIdx === 3) {
      let $ = window['jQuery'];
      $('#addPaymentData').click();
      if(this.payentDataFormValidity) {
        this.orgaSignupStepCurrentIdx ++;
      }
    } else if(this.orgaSignupStepCurrentIdx === 4) {
      this.router.navigate(['/']);
    }
  }
  getExtension(filename) {
    let parts = filename.split('.');
    return parts[parts.length - 1];
  }
  inputPdfChangeListener($event) {
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();

    if(this.getExtension(file.name) != 'pdf') {
      this.toastr.info('format du fichier  invalide', 'Info');
    } else {
      let that = this;
      myReader.onloadend = function(loadEvent: any) {
        that.payment.rib_iban_pdf  = myReader.result.toString().replace(/^[^,]*,/, '');
      };
      myReader.readAsDataURL(file);
    }
    console.log(this.payment);
  }

  passStep() {
    if(this.orgaSignupStepCurrentIdx <= 3 ) {
      this.orgaSignupStepCurrentIdx ++;
    } else {
      this.router.navigate(['/']);
    }
  }

  inputLogoImageListener($event): void {
    let image: any = new Image();
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    let that = this;
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      image.onload = (e) => {
        that.organisation.logo = loadEvent.target.result;
      }
    };
    myReader.readAsDataURL(file);
  }

  selectFile($event): Promise<any> {
    $event.target.parentElement.querySelector('.form-control-file').click();
    return;
  }

  selectFileribibanpdf($event): Promise<any> {
    $event.target.parentElement.querySelector('.form-control-file_rib_iban').click();
    return;
  }

}
